export default {
  title: 'Tags de Actividad',
  title_modal: 'Nueva tag',
  title_modal_edit: 'Editando tag',
  name: 'Nombre',
  color: 'Color',
  addNewButton: '+ Nueva tag'
}
